import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'auth',

  can: {
    route() {
      return this.child && (this.isAdmin() || this.isHRV());
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/AdminHRVPerimeter.js